import { useTranslation } from 'react-i18next';

interface StatusBarMobileProps {
    availableCount: number;
    unavailableCount: number;
    requestOrderCount: number;
    supportCounts: number;
    newOrderCounts: number;
    chefCounts: number;
}

export default function StatusBarMobile({ availableCount, unavailableCount, supportCounts, newOrderCounts, chefCounts }: StatusBarMobileProps) {
    const { t } = useTranslation();

    return (
        <>
            <div className="block md:hidden sticky bg-transparent w-full top-4 z-10 px-2 mb-4">
                <div className="flex justify-between">
                    <h2 className="text-[#000000] font-bold text-[16px] xs:text-[20px] bg-[#F1F5F9] p-2 rounded-lg w-fit h-fit">{t("order")}</h2>
                    <div className="bg-white py-2 px-4 rounded-full">
                        <div className="grid grid-cols-2 gap-2">
                            <div className="flex items-center gap-2">
                                <span className="relative inline-flex size-2 xs:size-3 rounded-full bg-gray-500"></span>
                                <span className="text-[8px] xs:text-[10px] lg:text-[14px] font-bold">{t("available")}{availableCount > 0 && ` (${availableCount})`}</span>
                            </div >
                            <div className="flex items-center gap-2">
                                <span className="relative inline-flex size-2 xs:size-3 rounded-full bg-danger"></span>
                                <span className="text-[8px] xs:text-[10px] lg:text-[14px] font-bold">{t("unavailable")}{unavailableCount > 0 && ` (${unavailableCount})`}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-end gap-2 mt-2">
                    <div className="bg-white py-2 px-4 rounded-full">
                        <div className="flex items-center gap-2">
                            <span className="relative flex size-2 xs:size-3">
                                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-purple-400 opacity-75"></span>
                                <span className="relative inline-flex size-2 xs:size-3 rounded-full bg-purple-500"></span>
                            </span>
                            <span className="text-[8px] xs:text-[10px] lg:text-[14px] font-bold">{t("support")}{supportCounts > 0 && ` (${supportCounts})`}</span>
                        </div>
                    </div>
                    <div className="bg-white py-2 px-4 rounded-full">
                        <div className="flex items-center gap-2">
                            <span className="relative flex size-2 xs:size-3">
                                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-blue-400 opacity-75"></span>
                                <span className="relative inline-flex size-2 xs:size-3 rounded-full bg-blue-500"></span>
                            </span>
                            <span className="text-[8px] xs:text-[10px] lg:text-[14px] font-bold">{t("newOrder")}{newOrderCounts > 0 && ` (${newOrderCounts})`}</span>
                        </div>
                    </div>
                    <div className="bg-white py-2 px-4 rounded-full">
                        <div className="flex items-center gap-2">
                            <span className="relative flex size-2 xs:size-3">
                                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75"></span>
                                <span className="relative inline-flex size-2 xs:size-3 rounded-full bg-green-500"></span>
                            </span>
                            <span className="text-[8px] xs:text-[10px] lg:text-[14px] font-bold">{t("ready")}{chefCounts > 0 && ` (${chefCounts})`}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
